/**
 * Layout - Main application layout wrapper.
 *
 * Provides:
 * - Header with navigation and wallet button
 * - Main content area with proper spacing
 * - Footer with branding
 */

import { type ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
  /** Show/hide header (default: true) */
  showHeader?: boolean;
  /** Show/hide footer (default: true) */
  showFooter?: boolean;
  /** Show minimal header: wallet + balance only, no logo/nav (default: false) */
  minimalHeader?: boolean;
  /** Callback when info button is clicked in the header */
  onInfoClick?: () => void;
  /** Additional class for main content */
  className?: string;
}

const Layout = ({
  children,
  showHeader = true,
  showFooter = true,
  minimalHeader = false,
  onInfoClick,
  className = ''
}: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col noise-overlay">
      {showHeader && <Header minimal={minimalHeader} onInfoClick={onInfoClick} />}

      <main
        className={`flex-1 relative z-10 ${showHeader ? 'pt-[88px]' : ''} ${className}`}
      >
        {children}
      </main>

      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
